import { CsaRawData, ValueLabel } from '../common';

export const csaListProperties: ValueLabel<keyof CsaRawData>[] = [
  {
    value: 'deaNumber',
    label: 'DEA #',
  },
  {
    value: 'expirationDate',
    label: 'Expiration Date',
  },
  {
    value: 'deaName',
    label: 'Name',
  },
  {
    value: 'csaBusStreet1',
    label: 'Address',
  },
  {
    value: 'csaBusCity',
    label: 'City',
  },
  {
    value: 'csaBusStateCd',
    label: 'State',
  },
  {
    value: 'csaBusPostalCd',
    label: 'Zip',
  },
];
